import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import AppArtemisBlogComponent from './components/artemis-blog.vue';
import MovementDisplay from './components/movement-display.vue';
import StageDisplay from './components/stage-display.vue';
import TimeDisplay from "./components/time-display.vue";
import linkDisplay from './components/link-display.vue';
import TelemetryStatusDisplay from './components/telemetry-status-display.vue';
import MenuComponent from './components/menu.vue';
import AppNasatvScheduleComponent from './components/nasatv-schedule.vue';
import AppTelemetryGraphic from './components/telemetry-graphic.vue';
import { isServiceLoading, isServiceSuccess, isStreamsData, ServiceResult, UNIT_SYSTEM_OPTIONS, UnitSystemOption } from './data.types';
import { LiveDataService } from './services/livedata.service';
import YoutubeStream from './components/youtube-stream.vue';
import { staticDataService } from './main';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const liveDataService = new LiveDataService();
let orionTelemetry = ref({ "error": new Error("Client not connected.") } as ServiceResult);
let artemisTimeline = ref({ "error": new Error("Client not connected.") } as ServiceResult);
let dsnData = ref({ "error": new Error("Client not connected.") } as ServiceResult);
let streamsData = ref({ error: new Error("No data yet.") } as ServiceResult);

liveDataService.dataBus.subscribe(data => {
  orionTelemetry.value = data;
});
liveDataService.timelineDataBus.subscribe(data => {
  artemisTimeline.value = data;
})
liveDataService.dsnDataBus.subscribe(data => {
  dsnData.value = data;
})

const fullscreenEnabled = ref<boolean>(false);
document.onfullscreenchange = () => {
  fullscreenEnabled.value = Boolean(document.fullscreenElement)
}

const videoEnabled = ref<boolean>(false);
const unitSystem = ref<UnitSystemOption>("METRIC")

const UNIT_CONVERTERS: { [key in UnitSystemOption]: { [key: string]: (v: number) => string } } = {
  "RAW": {
    "Meters per Second": (v: number) => `${v.toFixed(1)} m/s`,
    "Meters": (v: number) => `${v.toFixed(0)} m`,
    "Centimeters": (v: number) => `${v.toFixed(0)} cm`
  },
  "METRIC": {
    "Meters per Second": (v: number) => `${v.toFixed(1)} m/s`,
    "Meters": (v: number) => `${(v / 1000).toFixed(1)} km`,
    "Centimeters": (v: number) => `${(v / 100000).toFixed(1)} km`,
    //
    "Miles": (v: number) => `${(v * 1.609344).toFixed(1)} km`,
    "Feet per Second": (v: number) => `${(v * 1.09728).toFixed(1)} km/h`
  },
  "IMPERIAL": {
    "Meters per Second": (v: number) => `${(v * 2.236936).toFixed(1)} mph`,
    "Meters": (v: number) => `${(v / 1609.344).toFixed(1)} mi`,
    "Centimeters": (v: number) => `${(v / 160934.4).toFixed(1)} mi`,
    //
    "Miles": (v: number) => `${v.toFixed(1)} mi`,
    "Feet per Second": (v: number) => `${(v * 0.681818).toFixed(1)} mph`
  }
}
const currentUnitConverters = computed(() => {
  return UNIT_CONVERTERS[unitSystem.value]
})

function updateStreams() {
  streamsData.value = { loading: true };
  staticDataService.getStreams().then((data) => {
    if (isServiceSuccess(data)) {
      streamsData.value = data;
    }
  })
}

const streams = computed(() => {
  if (isServiceSuccess(streamsData.value)) {
    if (isStreamsData(streamsData.value.data)) {
      return streamsData.value.data
    } else {
      return "Invalid data"
    }
  } else if (isServiceLoading(streamsData.value)) {
    return "Loading..."
  } else {
    return `Error "${streamsData.value.error.name}": ${streamsData.value.error.message}`
  }
});

// let artemisTimelineTimer: number | null;
// function updateArtemisTimeline() {
//   artemisTimeline.value = { ...artemisTimeline.value, loading: true };
//   staticDataService.getTimeline().then((data) => {
//     if (isServiceSuccess(data)) {
//       artemisTimeline.value = data;
//     }
//   })
// }

function parseHash() {
  const hash = new URLSearchParams(decodeURIComponent(window.location.hash).substring(1));
  if (hash.get("video")) {
    videoEnabled.value = { "true": true, "1": true, "false": false, "0": false }[hash.get("video") || "false"] ?? false
  }
  if (UNIT_SYSTEM_OPTIONS.includes(hash.get("unitSystem") as UnitSystemOption)) {
    unitSystem.value = (hash.get("unitSystem") ?? "METRIC") as UnitSystemOption
  }
}

onMounted(() => {
  parseHash()
  window.addEventListener("hashchange", parseHash);
  // artemisTimelineTimer = setInterval(updateArtemisTimeline, 60 * 1000);
  // updateArtemisTimeline();
})

onUnmounted(() => {
  liveDataService.disconnect();
  // if (artemisTimelineTimer) {
  //   clearInterval(artemisTimelineTimer)
  //   artemisTimelineTimer = null
  // }
})

function updateData() {
  updateStreams();
  // updateArtemisTimeline();
}

watch(fullscreenEnabled, (val: boolean) => {
  let appEl = document.getElementById("app")
  if (appEl) {
    if (val) {
      appEl.requestFullscreen()
    } else {
      document.exitFullscreen()
    }
  }
})

function updateHash(key: string, value: string) {
  const hash = new URLSearchParams(decodeURIComponent(window.location.hash).substring(1));
  hash.set(key, value)
  window.location.hash = `#${hash.toString()}`
}

watch(videoEnabled, (val: boolean) => {
  updateHash('video', val ? '1' : '0');

  if (val) {
    updateStreams();
  }
})
watch(unitSystem, (val: UnitSystemOption) => {
  updateHash('unitSystem', val);
})

return { __sfc: true,liveDataService, orionTelemetry, artemisTimeline, dsnData, streamsData, fullscreenEnabled, videoEnabled, unitSystem, UNIT_CONVERTERS, currentUnitConverters, updateStreams, streams, parseHash, updateData, updateHash, AppArtemisBlogComponent, MovementDisplay, StageDisplay, TimeDisplay, linkDisplay, TelemetryStatusDisplay, MenuComponent, AppNasatvScheduleComponent, AppTelemetryGraphic, YoutubeStream }
}

})